import { CommitPage } from '../components/ModelPages';
import { publicMeta } from './public-meta';

export const meta = publicMeta(
  'Comic | Cartwheel',
  'Comic captures and quantifies human motion from video, producing production-ready motion data for animation, robotics, and research.',
);

export default CommitPage;
